import { escapeHtml } from '../escape.js';
import { editAttr, itemCollection, itemStr, labeledIntro, list, sectionOpen, str } from './helpers.js';
import type { PatternSectionT } from '../../schema/index.js';

/** testimonials — quote cards with author attribution. */
export function renderTestimonials(section: PatternSectionT): string {
  const heading = str(section.fields, 'heading');
  const label = str(section.fields, 'label');
  const items = list(section.fields, 'items')
    .map((item, index) => {
      const quote = itemStr(item, 'quote');
      const author = itemStr(item, 'author');
      if (!quote && !author) return '';
      const itemPath = `/items/${index}`;
      const lines = [`    <figure class="ve-testimonials__item"${editAttr(section, itemPath)}>`];
      if (quote) lines.push(`      <blockquote class="ve-testimonials__quote"><p>${escapeHtml(quote)}</p></blockquote>`);
      if (author) lines.push(`      <figcaption class="ve-testimonials__author">${escapeHtml(author)}</figcaption>`);
      lines.push('    </figure>');
      return lines.join('\n');
    })
    .filter(Boolean)
    .join('\n');

  const parts: string[] = [
    sectionOpen(section),
    ...labeledIntro(section, 'testimonials', heading, label),
    itemCollection(section, 'div', 've-testimonials__items', '/items', items),
    '</section>',
  ];
  return parts.join('\n');
}
